/**
 * Generic formatting utilities used across the matrimony module.
 */

/** Compute age from an ISO date-of-birth string. */
export const computeAge = (isoDob?: string | null): number => {
  if (!isoDob) return 0;
  const d = new Date(isoDob);
  if (Number.isNaN(d.getTime())) return 0;
  const now = new Date();
  let age = now.getFullYear() - d.getFullYear();
  const m = now.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < d.getDate())) age -= 1;
  return Math.max(0, age);
};

/** Format height in cm to a display label. */
export const toHeightLabel = (heightInCm?: number | null): string =>
  heightInCm ? `${heightInCm} cm` : "";

/** Format a number to Indian-rupee currency string. */
export const toCurrency = (n?: number | null): string => {
  if (n == null) return "";
  try {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(n);
  } catch {
    return `₹ ${n}`;
  }
};
